import React from "react";
import ROUTE_NAMES from "./routeNames";
import PrivateRoute from "./privateRoute";
import MainLayout from "../layout";
import UserDetails from "../views/users/userDetail";
import CMS from "../views/cms";
import Profile from "../views/auth/profile";
import Sites from "../views/sites";
import AddSites from "../views/sites/addSite";
import UpdateSite from "../views/sites/updateSite";
import SideDetail from "../views/sites/siteDetail";
import Cities from "../views/cities";
import CityDetail from "../views/cities/citiDetail";
import CityUpdate from "../views/cities/cityUpdate";
import ReportManager from "../views/reportManager";
import Feedback from "../views/feedback";
import FeedbackDetails from "../views/feedback/FeedbackDetails";
import Queries from "../views/queries";
import QueryDetails from "../views/queries/queryDetails";
/**
 * @function MainRoutes
 * @description for MainRoutes Private Routes
 * @returns JS for MainRoutes
 */

//pages import
const Dashboard = React.lazy(() => import("../views/dashboard"));
const Users = React.lazy(() => import("../views/users"));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: ROUTE_NAMES.BASE_ROUTE,
  element: <MainLayout />,
  children: [
    {
      path: ROUTE_NAMES.MAIN_ROUTES.DASHBOARD,
      element: (
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.USERS,
      element: (
        <PrivateRoute>
          <Users />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.USER,
      element: (
        <PrivateRoute>
          <UserDetails />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CMS,
      element: (
        <PrivateRoute>
          <CMS />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.PROFILE,
      element: (
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.SITES,
      element: (
        <PrivateRoute>
          <Sites />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ADD_SITES,
      element: (
        <PrivateRoute>
          <AddSites />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.UPDATE_SITE,
      element: (
        <PrivateRoute>
          <UpdateSite />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.SITES_DETAIL,
      element: (
        <PrivateRoute>
          <SideDetail />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CITIES,
      element: (
        <PrivateRoute>
          <Cities />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CITY_DETAIL,
      element: (
        <PrivateRoute>
          <CityDetail />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CITY_UPDATE,
      element: (
        <PrivateRoute>
          <CityUpdate />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.REPORT_MANAGEMENT,
      element: (
        <PrivateRoute>
          <ReportManager />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.FEEDBACK,
      element: (
        <PrivateRoute>
          <Feedback />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.FEEDBACK_DETAILS,
      element: (
        <PrivateRoute>
          <FeedbackDetails />
        </PrivateRoute>
      )
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.QUERIES,
      element: (
        <PrivateRoute>
          <Queries />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.QUERY_DETAILS,
      element: (
        <PrivateRoute>
          <QueryDetails />
        </PrivateRoute>
      ),
    },
  ],
};

export default MainRoutes;
